import { render, staticRenderFns } from "./menuindex.vue?vue&type=template&id=0553c921&scoped=true&"
import script from "./menuindex.vue?vue&type=script&lang=js&"
export * from "./menuindex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0553c921",
  null
  
)

export default component.exports